<template>
  <button
    :disabled="isLoading"
    class="submitButton"
    :class="isLoading && 'submitButton--disabled'"
    type="submit"
  >
    <div class="submitButton__contentWrapper">
      <span>{{ label }}</span>
      <FontAwesomeIcon
        v-if="isLoading"
        class="submitButton__spinner"
        icon="fa-solid fa-circle-notch fa-spin"
        spin
      />
    </div>
  </button>
</template>
<script lang="ts">
import {defineComponent, PropType} from 'vue'

export default defineComponent({
    name: 'SubmitButtonComponent',
    props: {
        isLoading: {
            type: Boolean as PropType<boolean>,
            required: true,
        },
        label: {
            type: String as PropType<string>,
            required: true,
        },
    },
})
</script>
<style lang="scss" scoped>
@import '@/sass/module/components/submit-button-component';
</style>


